<template>
  <div>
    <div class="main-title marTop64">
      咨询分类
    </div>
    <div class="main-cates">
      <div class="block youpin" @click="enterPage('youpin')">
        <div class="title">手机数码</div>
        <div class="desc">官方验、验机、保卖</div>
      </div>
      <div class="block game" @click="enterPage('game')">
        <div class="title">游戏</div>
        <div class="desc">购买、验号</div>
      </div>
      <div class="block book" @click="enterPage('book')">
        <div class="title">图书</div>
        <div class="desc">收书、卖书</div>
      </div>
      <!-- <div v-if="isHLSOpen" class="block given" @click="enterPage('given')">
        <div class="title">欢乐送</div>
        <div class="desc">星星、免费领</div>
      </div> -->
      <div class="block appeal" @click="enterPage('appeal')">
        <div class="title">申诉</div>
        <div class="desc">账号、商品违规</div>
      </div>
      <div class="block activity" @click="enterPage('activity')">
        <div class="title">活动</div>
        <div class="desc">活动、红包</div>
      </div>
      <div class="block trade" @click="enterPage('trade')">
        <div class="title">交易</div>
        <div class="desc">支付、退款</div>
      </div>
      <div class="block verdict" @click="enterPage('verdict')">
        <div class="title">平台介入</div>
        <div class="desc">催单、咨询</div>
      </div>
    </div>

    <div v-show="isOverlayVisible" class="over-lap"></div>
    <kefu-opt-dialog
      v-show="isKefuOptDialogVisible"
      tel="4006018080"
      @consult="toConsult"
      @close="closeDialog"
    ></kefu-opt-dialog>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'
import { hasArbitrationOrders } from '@api/resourceApi'
import { login, queryParams, getCookie } from '../../../lib/utils'
import { toast } from '../../../native'

import KefuOptDialog from '../KefuOptDialog/KefuOptDialog'

const query = queryParams()

export default {
  name: 'QuestionCategory',
  data() {
    return {
      zzv: query.zzv || this.$route.query.zzv || getCookie('v'),
      //  电话客服
      hasArbitrationOrders: false,
      //  对话框
      isKefuOptDialogVisible: false,
      isHLSOpen: false
    }
  },
  computed: {
    isOverlayVisible() {
      return this.isKefuOptDialogVisible || false
    }
  },
  methods: {
    enterPage(name) {
      lego.send({
        pagetype: 'ZZUP_HELPCENTER_BACKUP',
        actiontype: 'ENTRY_CLICK',
        backup: {
          name,
          from: this.from
        }
      })

      let url = ''

      if (name === 'youpin') {
        url = 'https://m.zhuanzhuan.com/system/zzappimservice/index.html?skillId=10011&robot=20'
      } else if (name === 'game') {
        url = 'https://m.zhuanzhuan.com/system/zzappimservice/index.html?skillId=10002&robot=12'
      } else if (name === 'book') {
        url = 'https://m.zhuanzhuan.com/system/zzappimservice/index.html?skillId=10001&robot=9'
      } else if (name === 'given') {
        url = 'https://m.zhuanzhuan.com/system/zzappimservice/index.html?skillId=10003&robot=13'
      } else if (name === 'appeal') {
        url = 'https://m.zhuanzhuan.com/system/zzappimservice/index.html?skillId=10006&robot=18'
      } else if (name === 'activity') {
        url = 'https://m.zhuanzhuan.com/system/zzappimservice/index.html?skillId=10009&robot=26'
      } else if (name === 'trade') {
        url = 'https://m.zhuanzhuan.com/system/zzappimservice/index.html?skillId=10009&robot=14'
      } else if (name === 'verdict') {
        // if (this.hasArbitrationOrders) {
        //   this.isKefuOptDialogVisible = true
        //   return
        // }
        url = 'https://m.zhuanzhuan.com/system/zzappimservice/index.html?skillId=10009&robot=21'
      }

      native.skipToUrl({
        targetUrl: url
      })
    },
    toConsult() {
      this.isKefuOptDialogVisible = false

      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/system/zzappimservice/index.html?skillId=10010'
      })
    },
    closeDialog() {
      this.isKefuOptDialogVisible = false
    }
  },
  created() {
    const vers = this.zzv && this.zzv.split('.').map((e) => Number(e))
    this.isHLSOpen = false
    if (
      vers &&
        ((vers[0] === 5 && vers[1] === 8 && vers[2] >= 5) ||
          (vers[0] === 5 && vers[1] >= 9) ||
          vers[0] >= 6)
    ) {
      this.isHLSOpen = true
    }

    login()
      .then(() => {
        console.info('登录成功. uid: ', getCookie('uid'))
        return hasArbitrationOrders()
      })
      .then((res) => {
        console.info(res)
        this.hasArbitrationOrders = res.hasArbitrationOrders
      })
      .catch((err) => {
        console.error(err)
        toast({
          msg: `${err.msg}\ncode: ${err.code}`,
          style: '2'
        })
      })
  },
  components: {
    KefuOptDialog
  }
}
</script>

<style lang="less" scoped>
  @import 'QuestionCategory.less';
  @import '../HelpCenter.less';
</style>
